import React, { useEffect } from "react";
import useConfirmationModal from "../../Components/Utils/DeleteModal";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

import MainHeader from "../../Components/Headres/Main_Header";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { deleteExtraObjects } from "../../Apis/ExtraObjectes/ExtraObjetcts_Api";
import { fetchGetAllExtraObjectApi } from "../../Redux/ExtraObjects_Slice";


const ExtraObjects = () => {
  const role = localStorage.getItem("role");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isLoading } = useSelector((state) => state.ExtraObjects || []);

  const { openModal: openDeleteModal, ModalComponent } = useConfirmationModal();

  useEffect(() => {
    dispatch(fetchGetAllExtraObjectApi());
  }, []);

  const handleEditClick = (id) => {
    navigate(`/AddExtraObjectForm/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await deleteExtraObjects(id);
      dispatch(fetchGetAllExtraObjectApi());
    } catch (error) {
      console.error("Error deleting extra object:", error);
    }
  };

  const confirmDelete = (id) => {
    openDeleteModal(() => handleDelete(id));
  };

  return (
    <Box p={3}>
      <MainHeader
        onNavigate={() => navigate("/AddExtraObjectForm")}
        title="Neue Extra"
      />

      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {data?.length ? data.map((item) => (
            <Grid size={4} key={item._id}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  bgcolor: "background.paper",
                  border: "1px solid #D6B981",
                  transition: "0.3s ease",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    boxShadow: 6,
                    transform: "translateY(-4px)",
                    borderColor: "primary.main"
                  }
                }}
              >
                <Box
                  sx={{
                    height: 200,
                    width: "100%",
                    borderRadius: 2,
                    mb: 2,
                    backgroundColor: "#f5f5f5"
                  }}
                >
                  <img
                    src={item.photo}
                    alt=""
                    style={{ height: "100%", width: "100%" }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1
                  }}
                >
                  <Typography
                    variant="h6"
                    noWrap
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      maxWidth: "70%",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Chip
                    label={`$${item.price}`}
                    size="small"
                    sx={{
                      bgcolor: "#D6B981",
                      color: "white",
                      fontWeight: 600,
                      fontSize: "0.75rem"
                    }}
                  />
                </Box>

                {item.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      height: 40,
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  >
                    {item.description}
                  </Typography>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    pt: 2,
                    borderTop: "1px dashed",
                    borderColor: "divider",
                    mt: 3
                  }}
                >
                  {role === "manager" && (
                    <>
                      <IconButton
                        onClick={() => handleEditClick(item._id)}
                        sx={{
                          bgcolor: "#D6B981",
                          color: "#fff",
                          "&:hover": {
                            bgcolor: "primary.main",
                            transform: "scale(1.1)"
                          },
                          transition: "all 0.2s"
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        onClick={() => confirmDelete(item._id)}
                        sx={{
                          bgcolor: "error.main",
                          color: "#fff",
                          "&:hover": {
                            bgcolor: "error.dark",
                            transform: "scale(1.1)"
                          },
                          transition: "all 0.2s"
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Paper>
            </Grid>
          )) : []}
        </Grid>
      )}
      <ModalComponent />
    </Box>
  );
};

export default ExtraObjects;
